module.exports = __webpack_public_path__ + "static/media/profile.422855ee.svg";